import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=23157476&scoped=true"
import script from "./MentionBox.vue?vue&type=script&lang=js"
export * from "./MentionBox.vue?vue&type=script&lang=js"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=23157476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23157476",
  null
  
)

export default component.exports